import { render, staticRenderFns } from "./ModalAgregarArea.vue?vue&type=template&id=c79a649e&scoped=true"
import script from "./ModalAgregarArea.vue?vue&type=script&lang=js"
export * from "./ModalAgregarArea.vue?vue&type=script&lang=js"
import style0 from "./ModalAgregarArea.vue?vue&type=style&index=0&id=c79a649e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79a649e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c79a649e')) {
      api.createRecord('c79a649e', component.options)
    } else {
      api.reload('c79a649e', component.options)
    }
    module.hot.accept("./ModalAgregarArea.vue?vue&type=template&id=c79a649e&scoped=true", function () {
      api.rerender('c79a649e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/permisos/ModalAgregarArea.vue"
export default component.exports